import { AsyncPaginate } from "react-select-async-paginate";
import { getTenant } from "../../../../utils/tenantManager";
import { getCategoriesApi } from "../../../../services/website/categoryService";

type OptionType = {
  value: string;
  label: string;
  data?: any;
};

type Additional = {
  page: number;
};

interface Props {
  value: OptionType | null;
  onChange: (value: OptionType | null) => void;
}

const PAGE_SIZE = 10;

export default function CategoryAsyncSelect({ value, onChange }: Props) {
  const tenantId = getTenant();

  const loadOptions = async (
    search: string,
    _loadedOptions: any,
    additional?: Additional,
  ) => {
    const page = additional?.page ?? 1;

    const res = await getCategoriesApi(page, PAGE_SIZE, tenantId!, search);

    return {
      options: res.data.map((x: any) => ({
        value: x.id,
        label: x.name,
        data: x,
      })),
      hasMore: page * PAGE_SIZE < res.totalCount,
      additional: {
        page: page + 1,
      },
    };
  };

  return (
    <AsyncPaginate
      value={value}
      loadOptions={loadOptions}
      additional={{ page: 1 }}
      debounceTimeout={300}
      isClearable
      placeholder="Search Category..."
      onChange={onChange}
    />
  );
}
